import { Component, OnInit } from "@angular/core";
import { Router } from '@angular/router';
import { EventEmitterService } from "../event-emitter.service";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.css"],
})
export class FooterComponent implements OnInit {
  constructor(public router: Router,private eventEmitterService:EventEmitterService) {}

  ngOnInit() {}
  gotoInjury() {
    this.router.navigate(["onlineservice/injury"]);
    this.eventEmitterService.onClickSideReport('injury')
  }
  gotoEmployer(){
    this.router.navigate(['/onlineservices'],{ preserveFragment: true } );
    setTimeout(function () {
      let el = document.getElementById("employers");
      el.scrollIntoView({ block: "center", behavior: "auto" });
    }, 500);
  }
  gotoTeam(){
    this.router.navigate(['/team']);
    localStorage.removeItem("selectedEmpId");
    setTimeout(function () {
      let el = document.getElementById("teamid");
      el.scrollIntoView({behavior: "smooth", block: "start"});
    }, 500);
  }
}
